import { useQuery } from '@tanstack/react-query';
import { errorMessages } from '~/constants/errorMessages.ts';
import api from '~/libs/api';
import { TExplanationQuestionResponse } from './types';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/store';
import { TGeneralInfo } from '~/modules/identification/forms/GeneralInfo/types';

const getExplanationQuestions = (clientType?: string) => async () => {
  try {
    const { data } = await api.get(
      `/dictionary-service/dictionary/explanation-question?client-type=${clientType}`
    );
    return data;
  } catch {
    throw Error(errorMessages.SERVICE_UNAVAILABLE);
  }
};

export const useExplanationQuestionsQuery = () => {
  const clientType = useSelector(
    (state: RootState) => (state.identification.formData.generalInfo as TGeneralInfo).type
  );

  const { data, error, isLoading, isError } = useQuery<TExplanationQuestionResponse>({
    queryKey: ['explanation-question'],
    queryFn: getExplanationQuestions(clientType),
    staleTime: 30 * 60 * 1000,
  });

  return {
    questions: data || [],
    error,
    isLoading,
    isError,
  };
};
